export default __webpack_public_path__ + "static/media/093-diagonal-arrow-5.d21ef39a.png";